import Vue from "vue";
import i18n from "@/fmt/i18n";

/*
enumName : name of the enumeration
enumObj  : enumeration object (import)
noGroupCode : true ? "" : enumName + '_'
*/
Vue.Enum = (enumName, enumObj, noGroupCode) => {
   Vue.filter(enumName, createEnumFilter(enumName, enumObj, noGroupCode));
};

function createEnumFilter(a, b, c) {
   return (value) => {
      return i18n.t(`${c ? "" : a + "_"}${b[value] != null || b[value] != undefined ? b[value] : "UNKNOWN"}`);
   };
}

import * as accountingEnums from "./accountingEnums";
import * as agencyEnums from "./agencyEnums";
import * as airportEnums from "./airportEnums";
import * as authorizationEnums from "./authorizationEnums";
import * as bigJobEnums from "./bigJobEnums";
import * as cacheEnums from "./cacheEnums";
import * as cdnEnums from "./cdnEnums";
import * as commonEnums from "./commonEnums";
import * as cronEnums from "./cronEnums";
import * as dashboardEnums from "./dashboardEnums";
import * as documentEnums from "./documentEnums";
import * as emailEnums from "./emailEnums";
import * as entityEnums from "./entityEnums";
import * as eventEnums from "./eventEnums";
import * as exchangeEnums from "./exchangeEnums";
import * as fileStoreEnums from "./fileStoreEnums";
import * as financeEnums from "./financeEnums";
import * as flightEnums from "./flightEnums";
import * as ftpEnums from "./ftpEnums";
import * as gsaEnums from "./gsaEnums";
import * as hotelEnums from "./hotelEnums";
import * as insuranceEnums from "./insuranceEnums";
import * as invoiceEnums from "./invoiceEnums";
import * as jobHookEnums from "./jobHookEnums";
import * as locationEnums from "./locationEnums";
import * as noteEnums from "./noteEnums";
import * as notificationEnums from "./notificationEnums";
import * as orderEnums from "./orderEnums";
import * as paymentEnums from "./paymentEnums";
import * as processEnums from "./processEnums";
import * as providerEnums from "./providerEnums";
import * as rentACarEnums from "./rentACarEnums";
import * as reportEnums from "./reportEnums";
import * as schmetterlingEnums from "./schmetterlingEnums";
import * as supplierEnums from "./supplierEnums";
import * as taskEnums from "./taskEnums";
import * as testAutomationEnums from "./testAutomationEnums";
import * as transferEnums from "./transferEnums";
import * as userEnums from "./userEnums";

/*
Vue.Enum generators
   - import enums
   - use with Vue.Enum function
*/

//AccountingEnums
Vue.Enum("EAccAccountStatus", accountingEnums.EAccAccountStatus);
Vue.Enum("EAccAccountType", accountingEnums.EAccAccountType);
Vue.Enum("EAccAccountSubType", accountingEnums.EAccAccountSubType);
Vue.Enum("EAccTransactionType", accountingEnums.EAccTransactionType);
Vue.Enum("EAccTrxGroupBy", accountingEnums.EAccTrxGroupBy);
Vue.Enum("EAccDateType", accountingEnums.EAccDateType);
Vue.Enum("EAccReceiptType", accountingEnums.EAccReceiptType);

//AgencyEnums
Vue.Enum("EAgencyContactTitle", agencyEnums.EAgencyContactTitle);

//AirportEnums
Vue.Enum("EAirportType", airportEnums.EAirportType);
Vue.Enum("EAirportVerifyStatus", airportEnums.EAirportVerifyStatus);

//AuthorizationEnums
Vue.Enum("EAuthAuthType", authorizationEnums.EAuthAuthType);
Vue.Enum("EAuthActionType", authorizationEnums.EAuthActionType);
Vue.Enum("EAuthModalMode", authorizationEnums.EAuthModalMode);
Vue.Enum("EAuthAgentRoles", authorizationEnums.EAuthAgentRoles);

//BigJobEnums
Vue.Enum("EBigJobType", bigJobEnums.EBigJobType);
Vue.Enum("EBigJobStatus", bigJobEnums.EBigJobStatus);

//CacheEnums
Vue.Enum("EMemCacheType", cacheEnums.EMemCacheType);

//CdnEnums
Vue.Enum("ECdnDocType", cdnEnums.ECdnDocType);
Vue.Enum("ECdnDocGroupType", cdnEnums.ECdnDocGroupType);
Vue.Enum("ECdnFileType", cdnEnums.ECdnFileType);

//CommonEnums
Vue.Enum("EComResult", commonEnums.EComResult);
Vue.Enum("EExtResultCode", commonEnums.EExtResultCode);
Vue.Enum("EComState", commonEnums.EComState);
Vue.Enum("EComStatus", commonEnums.EComStatus);
Vue.Enum("EComAbility", commonEnums.EComAbility);
Vue.Enum("EComGender", commonEnums.EComGender);
Vue.Enum("EComLanguage", commonEnums.EComLanguage);
Vue.Enum("EComCurrency", commonEnums.EComCurrency);
Vue.Enum("EComCountryType", commonEnums.EComCountryType);
Vue.Enum("EComApplication", commonEnums.EComApplication);
Vue.Enum("EComUnit", commonEnums.EComUnit);
Vue.Enum("EComLayer", commonEnums.EComLayer);
Vue.Enum("EComLogLevel", commonEnums.EComLogLevel);
Vue.Enum("EComObjectType", commonEnums.EComObjectType);
Vue.Enum("EComDay", commonEnums.EComDay);

//CronEnums
Vue.Enum("ECronJobType", cronEnums.ECronJobType);

//DashboardEnums
Vue.Enum("EDashWidgetType", dashboardEnums.EDashWidgetType);
Vue.Enum("EDashWidgetItem", dashboardEnums.EDashWidgetItem);
Vue.Enum("EDashMainWidget", dashboardEnums.EDashMainWidget);
Vue.Enum("EDashSideWidget", dashboardEnums.EDashSideWidget);

Vue.Enum("widgets", dashboardEnums.widgets, true);
Vue.Enum("widgetsResponseModelMap", dashboardEnums.widgetsResponseModelMap);
Vue.Enum("EDashMainWidgetType", dashboardEnums.EDashMainWidgetType);
Vue.Enum("EDashMainWidget2", dashboardEnums.EDashMainWidget2);
Vue.Enum("widgets2", dashboardEnums.widgets2, true);
Vue.Enum("widgetsResponseModelMap2", dashboardEnums.widgetsResponseModelMap2);

//DocumentEnums
Vue.Enum("EDocDocumentType", documentEnums.EDocDocumentType);
Vue.Enum("EDocFileType", documentEnums.EDocFileType);
Vue.Enum("EDocFontType", documentEnums.EDocFontType);

//EmailEnums
Vue.Enum("EEmailType", emailEnums.EEmailType);
Vue.Enum("EEmailStatus", emailEnums.EEmailStatus);
Vue.Enum("EEmailImportance", emailEnums.EEmailImportance);
Vue.Enum("EEmailIOType", emailEnums.EEmailIOType);
Vue.Enum("EEmailFromType", emailEnums.EEmailFromType);

//EntityEnums
Vue.Enum("EEntityCheckStatus", entityEnums.EEntityCheckStatus);
Vue.Enum("EEntityCheckType", entityEnums.EEntityCheckType);

//EventEnums
Vue.Enum("EEventType", eventEnums.EEventType);

//ExchangeEnums
Vue.Enum("EExchangeImplementationType", exchangeEnums.EExchangeImplementationType);

//FileStoreEnums
Vue.Enum("EFsFileType", fileStoreEnums.EFsFileType);
Vue.Enum("EFsFileSubType", fileStoreEnums.EFsFileSubType);
Vue.Enum("EFsFileExtension", fileStoreEnums.EFsFileExtension);

//FinanceEnums
Vue.Enum("EBalanceUpdateTrxType", financeEnums.EBalanceUpdateTrxType);
Vue.Enum("EPayCommissionType", financeEnums.EPayCommissionType);

//FlightEnums
Vue.Enum("EFltPaxType", flightEnums.EFltPaxType);
Vue.Enum("EFltPaxSubType", flightEnums.EFltPaxSubType);
Vue.Enum("EFltCabinType", flightEnums.EFltCabinType);
Vue.Enum("EFltTripType", flightEnums.EFltTripType);
Vue.Enum("EFltCountryType", flightEnums.EFltCountryType);
Vue.Enum("EFltPnrStatus", flightEnums.EFltPnrStatus);
Vue.Enum("EFltPnrImportType", flightEnums.EFltPnrImportType);
Vue.Enum("EFltEticketStatus", flightEnums.EFltEticketStatus);
Vue.Enum("EFltTicketUsageStatus", flightEnums.EFltTicketUsageStatus);
Vue.Enum("EFltAncillaryStatus", flightEnums.EFltAncillaryStatus);
Vue.Enum("EFltFlightStatus", flightEnums.EFltFlightStatus);
Vue.Enum("EFltSegmentStatus", flightEnums.EFltSegmentStatus);
Vue.Enum("EFltEticketTrxType", flightEnums.EFltEticketTrxType);
Vue.Enum("EFltPnrFlow", flightEnums.EFltPnrFlow);
Vue.Enum("EFltPnrIssueType", flightEnums.EFltPnrIssueType);
Vue.Enum("EFltPnrReverseType", flightEnums.EFltPnrReverseType);
Vue.Enum("EFltPnrReverseEnabledType", flightEnums.EFltPnrReverseEnabledType);
Vue.Enum("EFltAirportType", flightEnums.EFltAirportType);
Vue.Enum("EFltSearchType", flightEnums.EFltSearchType);
Vue.Enum("EFltSearchRuleSearchType", flightEnums.EFltSearchRuleSearchType);
Vue.Enum("EFltCommissionAmountType", flightEnums.EFltCommissionAmountType);
Vue.Enum("EFltCommissionType", flightEnums.EFltCommissionType);
Vue.Enum("EFltReverseReason", flightEnums.EFltReverseReason);
Vue.Enum("EFltIrregularAirline", flightEnums.EFltIrregularAirline);
Vue.Enum("EFltSsrType", flightEnums.EFltSsrType);
Vue.Enum("EFltSsrState", flightEnums.EFltSsrState);
Vue.Enum("EFltBaggageUnit", flightEnums.EFltBaggageUnit);
Vue.Enum("EFltBaggageType", flightEnums.EFltBaggageType);
Vue.Enum("EFltPnrUserActionType", flightEnums.EFltPnrUserActionType);
Vue.Enum("EFltAncillaryType", flightEnums.EFltAncillaryType, true);
Vue.Enum("EFltSsrMealType", flightEnums.EFltSsrMealType);
Vue.Enum("EFltSsrMealTypeEnum", flightEnums.EFltSsrMealType, true);
Vue.Enum("EFltSsrMealTypeReverse", flightEnums.EFltSsrMealTypeReverse);
Vue.Enum("EFltSsrWheelchairType", flightEnums.EFltSsrWheelchairType);
Vue.Enum("EFltSsrWheelchairTypeEnum", flightEnums.EFltSsrWheelchairType, true);
Vue.Enum("EFltSsrWheelchairTypeReverse", flightEnums.EFltSsrWheelchairTypeReverse);
Vue.Enum("EFltPnrCcCheckStatus", flightEnums.EFltPnrCcCheckStatus);
Vue.Enum("EFltReportDateType", flightEnums.EFltReportDateType);
Vue.Enum("EFltWarnType", flightEnums.EFltWarnType);
Vue.Enum("EFltReissueAvailType", flightEnums.EFltReissueAvailType);
Vue.Enum("EFltFlightTimeTableStatus", flightEnums.EFltFlightTimeTableStatus);
Vue.Enum("EFltSeatStatus", flightEnums.EFltSeatStatus);
Vue.Enum("EFltSeatType", flightEnums.EFltSeatType);
Vue.Enum("EFltSeatLayout", flightEnums.EFltSeatLayout, true);
Vue.Enum("EFltEticketNoShowStatus", flightEnums.EFltEticketNoShowStatus);

//FtpEnums
Vue.Enum("EFtpDocType", ftpEnums.EFtpDocType);

//GsaEnums
Vue.Enum("EGsaType", gsaEnums.EGsaType);

//HotelEnums
Vue.Enum("EHotelStatus", hotelEnums.EHotelStatus);
Vue.Enum("EHtlMapingType", hotelEnums.EHtlMapingType);
Vue.Enum("EHtlMapingStatus", hotelEnums.EHtlMapingStatus);
Vue.Enum("EHotelRegion", hotelEnums.EHotelRegion);
Vue.Enum("EHtlGuestType", hotelEnums.EHtlGuestType);
Vue.Enum("EHtlVoucherStatus", hotelEnums.EHtlVoucherStatus);
Vue.Enum("EHtlRoomPriceStatus", hotelEnums.EHtlRoomPriceStatus);
Vue.Enum("EHtlAddOnStatus", hotelEnums.EHtlAddOnStatus);
Vue.Enum("EHtlImportType", hotelEnums.EHtlImportType);
Vue.Enum("EHtlAmountType", hotelEnums.EHtlAmountType);
Vue.Enum("EHtlPolicyType", hotelEnums.EHtlPolicyType);
Vue.Enum("EHtlCommissionType", hotelEnums.EHtlCommissionType);
Vue.Enum("EHtlCommissionRatioType", hotelEnums.EHtlCommissionRatioType);
Vue.Enum("EHtlSearchType", hotelEnums.EHtlSearchType);
Vue.Enum("EHtlContentUpdateType", hotelEnums.EHtlContentUpdateType);
Vue.Enum("EHtlContentItemStatus", hotelEnums.EHtlContentItemStatus);
Vue.Enum("EHtlHotelVerifyStatus", hotelEnums.EHtlHotelVerifyStatus);
Vue.Enum("EHtlOptionNotifyStatus", hotelEnums.EHtlOptionNotifyStatus);
Vue.Enum("EHtlImageCategory", hotelEnums.EHtlImageCategory);
Vue.Enum("EHtlVoucherReverseEnabledType", hotelEnums.EHtlVoucherReverseEnabledType);
Vue.Enum("EHtlAmountForceType", hotelEnums.EHtlAmountForceType);
Vue.Enum("EHtlRefundType", hotelEnums.EHtlRefundType);
Vue.Enum("EHtlPriceViewType", hotelEnums.EHtlPriceViewType);
Vue.Enum("EHtlPaymentType", hotelEnums.EHtlPaymentType);
Vue.Enum("EHtlPaymentStatus", hotelEnums.EHtlPaymentStatus);
Vue.Enum("EHotelContactTitle", hotelEnums.EHotelContactTitle);
Vue.Enum("EHtlFacilityType", hotelEnums.EHtlFacilityType);
Vue.Enum("EHtlBedType", hotelEnums.EHtlBedType);
Vue.Enum("EHtlRoomGroup", hotelEnums.EHtlRoomGroup);
Vue.Enum("EHtlStopType", hotelEnums.EHtlStopType);
Vue.Enum("EHtlPenaltyType", hotelEnums.EHtlPenaltyType);
Vue.Enum("EHtlPriceRestrictionType", hotelEnums.EHtlPriceRestrictionType);
Vue.Enum("EHtlNoteType", hotelEnums.EHtlNoteType);
Vue.Enum("EHtlNoteSubType", hotelEnums.EHtlNoteSubType);
Vue.Enum("EHtlPageType", hotelEnums.EHtlPageType);
Vue.Enum("EHtlSpoType", hotelEnums.EHtlSpoType);
Vue.Enum("EHtlSpoFreeDayType", hotelEnums.EHtlSpoFreeDayType);
Vue.Enum("EHtlContentImportType", hotelEnums.EHtlContentImportType);
Vue.Enum("EHtlKickbackType", hotelEnums.EHtlKickbackType);
Vue.Enum("EHtlContractType", hotelEnums.EHtlContractType);
Vue.Enum("EHtlHotelStarCategory", hotelEnums.EHtlHotelStarCategory);
Vue.Enum("EHtlSpoCumulateType", hotelEnums.EHtlSpoCumulateType);
Vue.Enum("EHtlSearchCacheSyncType", hotelEnums.EHtlSearchCacheSyncType);
Vue.Enum("EHtlSearchCacheSyncStatus", hotelEnums.EHtlSearchCacheSyncStatus);
Vue.Enum("EHtlChildType", hotelEnums.EHtlChildType);
Vue.Enum("EHtlContractSettingsType", hotelEnums.EHtlContractSettingsType);
Vue.Enum("EHtlPriceBlockStatus", hotelEnums.EHtlPriceBlockStatus);

//InsuranceEnums
Vue.Enum("EInsPolicyStatus", insuranceEnums.EInsPolicyStatus);
Vue.Enum("EInsPolicyPriceStatus", insuranceEnums.EInsPolicyPriceStatus);
Vue.Enum("EInsImportType", insuranceEnums.EInsImportType);
Vue.Enum("EInsPolicyPriceType", insuranceEnums.EInsPolicyPriceType);

//InvoiceEnums
Vue.Enum("EInvoiceStatus", invoiceEnums.EInvoiceStatus);
Vue.Enum("EInvoiceType", invoiceEnums.EInvoiceType);
Vue.Enum("EInvoiceHeaderType", invoiceEnums.EInvoiceHeaderType);
Vue.Enum("EInvoiceIO", invoiceEnums.EInvoiceIO);
Vue.Enum("EInvoiceTrxViewType", invoiceEnums.EInvoiceTrxViewType);
Vue.Enum("EInvoicePackageType", invoiceEnums.EInvoicePackageType);
Vue.Enum("EInvoiceDateType", invoiceEnums.EInvoiceDateType);
Vue.Enum("EInvoicePeriodType", invoiceEnums.EInvoicePeriodType);

//JobHookEnums
Vue.Enum("EJobHookIntegrationType", jobHookEnums.EJobHookIntegrationType);
Vue.Enum("EJobHookJobType", jobHookEnums.EJobHookJobType);
Vue.Enum("EJobHookJobStatus", jobHookEnums.EJobHookJobStatus);

//LocationEnums
Vue.Enum("ELocationCategory", locationEnums.ELocationCategory);
Vue.Enum("ELocationStatus", locationEnums.ELocationStatus);
Vue.Enum("ELocationType", locationEnums.ELocationType);
Vue.Enum("EDestinationType", locationEnums.EDestinationType);
Vue.Enum("EDestinationSyncStatus", locationEnums.EDestinationSyncStatus);
Vue.Enum("ECountryPatternType", locationEnums.ECountryPatternType);

//NoteEnums
Vue.Enum("ENoteVisibility", noteEnums.ENoteVisibility);
Vue.Enum("EScriptPlaceholder", noteEnums.EScriptPlaceholder);
Vue.Enum("EContactType", noteEnums.EContactType);

//NotificationEnums
Vue.Enum("ENotificationType", notificationEnums.ENotificationType);
Vue.Enum("ENotificationStatus", notificationEnums.ENotificationStatus);
Vue.Enum("EAnnouncementCategory", notificationEnums.EAnnouncementCategory);

//OrderEnums
Vue.Enum("EOdrSearchStatus", orderEnums.EOdrSearchStatus);
Vue.Enum("EOdrOrderStatus", orderEnums.EOdrOrderStatus);
Vue.Enum("EOdrType", orderEnums.EOdrType);
Vue.Enum("EOdrEntityType", orderEnums.EOdrEntityType);
Vue.Enum("EOdrSubEntityType", orderEnums.EOdrSubEntityType);
Vue.Enum("EOdrImportType", orderEnums.EOdrImportType);
Vue.Enum("EOdrErrorType", orderEnums.EOdrErrorType);
Vue.Enum("EOdrTrxType", orderEnums.EOdrTrxType);
Vue.Enum("EOdrSearchHotelDateType", orderEnums.EOdrSearchHotelDateType);
Vue.Enum("EOdrSearchTransferDateType", orderEnums.EOdrSearchTransferDateType);
Vue.Enum("EOdrSearchRentACarDateType", orderEnums.EOdrSearchRentACarDateType);
Vue.Enum("EOdrConfirmationSource", orderEnums.EOdrConfirmationSource);

//PaymentEnums
Vue.Enum("EPayPaymentStatus", paymentEnums.EPayPaymentStatus);
Vue.Enum("EPayVcardStatus", paymentEnums.EPayVcardStatus);
Vue.Enum("EPayVcardTrxStatus", paymentEnums.EPayVcardTrxStatus);
Vue.Enum("EPayVcardTrxType", paymentEnums.EPayVcardTrxType);
Vue.Enum("EPayPaymentType", paymentEnums.EPayPaymentType);
Vue.Enum("EPayTransactionType", paymentEnums.EPayTransactionType);
Vue.Enum("EPayVposImplementationType", paymentEnums.EPayVposImplementationType);
Vue.Enum("EPayCardType", paymentEnums.EPayCardType);
Vue.Enum("EPayCardBrand", paymentEnums.EPayCardBrand);
Vue.Enum("EPayCardOwner", paymentEnums.EPayCardOwner);
Vue.Enum("EPayPaymentFinalizeType", paymentEnums.EPayPaymentFinalizeType);

//ProcessEnums
Vue.Enum("EProcessType", processEnums.EProcessType);
Vue.Enum("EProcessStatus", processEnums.EProcessStatus);
Vue.Enum("EProgressType", processEnums.EProgressType);
Vue.Enum("EProgressStatus", processEnums.EProgressStatus);

//ProviderEnums
Vue.Enum("EProProductType", providerEnums.EProProductType);
Vue.Enum("EProProviderType", providerEnums.EProProviderType);
Vue.Enum("EProChannelType", providerEnums.EProChannelType);
Vue.Enum("EProSalesChannelType", providerEnums.EProSalesChannelType);
Vue.Enum("EProImplementationType", providerEnums.EProImplementationType);
Vue.Enum("EProEodType", providerEnums.EProEodType);
Vue.Enum("EProLoginStatus", providerEnums.EProLoginStatus);

//RentACarEnums
Vue.Enum("ERacBodyType", rentACarEnums.ERacBodyType);
Vue.Enum("ERacProductType", rentACarEnums.ERacProductType);
Vue.Enum("ERacAncillaryType", rentACarEnums.ERacAncillaryType);
Vue.Enum("ERacAncillaryEnums", rentACarEnums.ERacAncillaryEnums);
Vue.Enum("ERacAncillaryTypeIcon", rentACarEnums.ERacAncillaryTypeIcon, true);
Vue.Enum("ERacPassengerCapacity", rentACarEnums.ERacPassengerCapacity);
Vue.Enum("ERacFacilityType", rentACarEnums.ERacFacilityType);
Vue.Enum("ERacRnrStatus", rentACarEnums.ERacRnrStatus);
Vue.Enum("ERacVehicleStatus", rentACarEnums.ERacVehicleStatus);
Vue.Enum("ERacVehiclePriceStatus", rentACarEnums.ERacVehiclePriceStatus);
Vue.Enum("ERacAncillaryStatus", rentACarEnums.ERacAncillaryStatus);
Vue.Enum("ERacGearType", rentACarEnums.ERacGearType);
Vue.Enum("ERacFuelType", rentACarEnums.ERacFuelType);
Vue.Enum("ERacImportType", rentACarEnums.ERacImportType);
Vue.Enum("ERacCommissionRatioType", rentACarEnums.ERacCommissionRatioType);
Vue.Enum("ERacCommissionType", rentACarEnums.ERacCommissionType);
Vue.Enum("ERacCommissionAmountType", rentACarEnums.ERacCommissionAmountType);
Vue.Enum("ERacProviderDocType", rentACarEnums.ERacProviderDocType);
Vue.Enum("ERacRnrReverseEnabledType", rentACarEnums.ERacRnrReverseEnabledType);

//ReportEnums
Vue.Enum("EReportFlightDateType", reportEnums.EReportFlightDateType);
Vue.Enum("EReportHotelDateType", reportEnums.EReportHotelDateType);
Vue.Enum("EReportTransferDateType", reportEnums.EReportTransferDateType);
Vue.Enum("EReportRentACarDateType", reportEnums.EReportRentACarDateType);
Vue.Enum("EReportRentACarReportType", reportEnums.EReportRentACarReportType);
Vue.Enum("EReportSalesSumReportType", reportEnums.EReportSalesSumReportType);
Vue.Enum("EReportSalesType", reportEnums.EReportSalesType);
Vue.Enum("EReportHotelSearchType", reportEnums.EReportHotelSearchType);
Vue.Enum("EReportCmnGsaInvoiceProductType", reportEnums.EReportCmnGsaInvoiceProductType);

//SchmetterlingEnums
Vue.Enum("ESchmetterlingOrderStatus", schmetterlingEnums.ESchmetterlingOrderStatus);

//SupplierEnums
Vue.Enum("ESupSupplierType", supplierEnums.ESupSupplierType);

//TaskEnums
Vue.Enum("ETaskType", taskEnums.ETaskType);
Vue.Enum("ETaskSubType", taskEnums.ETaskSubType);
Vue.Enum("ETaskStatus", taskEnums.ETaskStatus);
Vue.Enum("ETaskSubStatus", taskEnums.ETaskSubStatus);
Vue.Enum("ETaskClosingType", taskEnums.ETaskClosingType);
Vue.Enum("ETaskSource", taskEnums.ETaskSource);
Vue.Enum("ETaskMedia", taskEnums.ETaskMedia);
Vue.Enum("ETaskVisibility", taskEnums.ETaskVisibility);
Vue.Enum("ETaskPnrReverseReason", taskEnums.ETaskPnrReverseReason);
Vue.Enum("ETaskVoucherReverseReason", taskEnums.ETaskVoucherReverseReason);
Vue.Enum("ETaskTnrReverseReason", taskEnums.ETaskTnrReverseReason);
Vue.Enum("ETaskRnrReverseReason", taskEnums.ETaskRnrReverseReason);

//TestAutomationEnums
Vue.Enum("ETasScenarioType", testAutomationEnums.ETasScenarioType);
Vue.Enum("ETasLogStatus", testAutomationEnums.ETasLogStatus);

//TransferEnums
Vue.Enum("ETrfVehicleCategory", transferEnums.ETrfVehicleCategory);
Vue.Enum("ETrfSaleStatus", transferEnums.ETrfSaleStatus);
Vue.Enum("ETrfAncillaryType", transferEnums.ETrfAncillaryType);
Vue.Enum("ETrfTnrStatus", transferEnums.ETrfTnrStatus);
Vue.Enum("ETrfLegStatus", transferEnums.ETrfLegStatus);
Vue.Enum("ETrfAncillaryStatus", transferEnums.ETrfAncillaryStatus);
Vue.Enum("ETrfOperationStatus", transferEnums.ETrfOperationStatus);
Vue.Enum("ETrfImportType", transferEnums.ETrfImportType);
Vue.Enum("ETrfTripType", transferEnums.ETrfTripType);
Vue.Enum("ETrfRouteType", transferEnums.ETrfRouteType);
Vue.Enum("ETrfCommissionRatioType", transferEnums.ETrfCommissionRatioType);
Vue.Enum("ETrfCommisionType", transferEnums.ETrfCommisionType);
Vue.Enum("ETrfCommisionAmountType", transferEnums.ETrfCommisionAmountType);
Vue.Enum("ETrfTransferType", transferEnums.ETrfTransferType);
Vue.Enum("ETrfProductType", transferEnums.ETrfProductType);
Vue.Enum("ETrfTravelerType", transferEnums.ETrfTravelerType);
Vue.Enum("ETrfRouteOriginType", transferEnums.ETrfRouteOriginType);
Vue.Enum("ETrfMappingType", transferEnums.ETrfMappingType);
Vue.Enum("ETrfMappingStatus", transferEnums.ETrfMappingStatus);
Vue.Enum("ETrfFacilityType", transferEnums.ETrfFacilityType);
Vue.Enum("ETrfTnrReverseEnabledType", transferEnums.ETrfTnrReverseEnabledType);

//UserEnums
Vue.Enum("EUserType", userEnums.EUserType);
Vue.Enum("EUsrOperatorTaskAvailabilty", userEnums.EUsrOperatorTaskAvailabilty);
Vue.Enum("EUsrOperatorCallAvailabilty", userEnums.EUsrOperatorCallAvailabilty);
Vue.Enum("EUserTotp", userEnums.EUserTotp);
Vue.Enum("EUserLoginStatus", userEnums.EUserLoginStatus);
Vue.Enum("EUserOnBeHalfOfStatus", userEnums.EUserOnBeHalfOfStatus);
